import React from 'react'
import { Box, Flex, Text } from '@fundamentals'
import { Chip } from '@common/material'
import { UserAvatar } from '@common/UserAvatar'
import { Palette } from '@core/theme/color-palette-siteassist'
import { IUser } from '@core/entities/user'

type UserCardHeaderProps = {
  user: Pick<IUser, 'firstName' | 'lastName' | 'company'>
  name: string
  badgeLabel?: string | null
  onClick?: (e: React.MouseEvent) => void
}

export const UserCardHeader: React.FC<UserCardHeaderProps> = ({
  user,
  name,
  badgeLabel,
  onClick,
}) => (
  <Flex
    alignItems='center'
    gap={1.5}
    mb={1}
    p={1.5}
    onClick={onClick}
    sx={{
      minWidth: 0,
      ...(onClick && {
        cursor: 'pointer',
        '&:hover': { bgcolor: Palette.Grey[50] },
      }),
    }}
  >
    <UserAvatar user={user} sx={{ width: 36, height: 36 }} />
    <Box flex={1} minWidth={0}>
      <Text fontSize={14} fontWeight={500} noWrap>
        {name}
      </Text>
      <Flex alignItems='center' gap={1} sx={{ minWidth: 0 }}>
        {user.company && (
          <Text fontSize={12} color='text.primary' noWrap>
            {user.company}
          </Text>
        )}
        {badgeLabel && (
          <Chip
            label={badgeLabel}
            size='small'
            sx={{
              flexShrink: 0,
              borderRadius: 1,
              fontSize: 12,
            }}
          />
        )}
      </Flex>
    </Box>
  </Flex>
)
